<div class="container my-3">
  <div class="card shadow-sm">
    <div class="card-body">
      <h3 class="mb-2 title">Select Voucher</h3>

      <form [formGroup]="voucherSectionsForm">
        <div class="mb-3">
          <div class="input-container">
            <label class="label"><input type="checkbox" (change)="toggleFullVoucher($event)" [checked]="isFullVoucherChecked()"  class="me-1">Full Voucher</label>
          </div>
          <div class="divider"></div>
          <div class="input-container" *ngIf="voucherSectionsForm.get('hotelsVoucher')?.enabled">
            <label class="label"><input formControlName="hotelsVoucher" type="checkbox" class="me-1" (change)="onHotelsVoucherChange($event)">Hotels Voucher</label>
          </div>
          <!-- Individual Hotels — shown only when Hotels Voucher checked + multiple hotels -->
          <ng-container *ngIf="showIndividualHotels">
            <div class="input-container ps-4" 
                 *ngFor="let hotel of hotelsList; let i = index"
                 style="border-left: 2px solid #4198aa; margin-left: 16px;">
              <label class="label">
                     <input [formControlName]="'hotel_' + i" type="checkbox" class="me-1" (change)="onIndividualHotelChange()">
                <strong>{{ hotel.hotelName }}</strong>
              </label>
            </div>
          </ng-container>
          <div class="input-container" *ngIf="voucherSectionsForm.get('transportationVoucher')?.enabled">
            <label class="label"><input formControlName="transportationVoucher" type="checkbox"  class="me-1">Transportation Voucher</label>
          </div>
          <div class="input-container" *ngIf="voucherSectionsForm.get('routeCraftVoucher')?.enabled">
            <label class="label"><input formControlName="routeCraftVoucher" type="checkbox" class="me-1">Route Craft Voucher</label>
          </div>
        </div>

        <ion-button type="submit" class="filled-blue-btn" [disabled]="voucherSectionsForm.invalid" (click)="onSubmit()">
          Submit
        </ion-button>
      </form>
    </div>
  </div>
</div>
